export class CartModificationError extends Error {
  public productId: string
  constructor(statusCode: string, productId: string) {
    super(statusCode)
    this.productId = productId
    this.name = 'CartModificationError'
  }
}
